import React from 'react';
import { cn } from '@/lib/utils';
import Sidebar from './Sidebar';
import { useSidebar } from '@/contexts/SidebarContext';
import { Menu } from 'lucide-react';
import { useAuthContext } from '@/contexts/AuthContext';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const { 
    collapsed, 
    showMobileSidebar, 
    setShowMobileSidebar,
    isMobile
  } = useSidebar();
  
  // Obter o contexto de autenticação
  const authContext = useAuthContext();
  
  // Criar um usuário fictício se não houver usuário autenticado
  const user = authContext.user || {
    id: 'temp-user-id',
    email: 'usuario@exemplo.com',
    user_metadata: {
      full_name: 'Usuário Temporário',
      avatar_url: '',
    }
  };

  // Toggle sidebar function for mobile
  const toggleMobileSidebar = () => {
    console.log('Toggling mobile sidebar, current state:', showMobileSidebar);
    setShowMobileSidebar(!showMobileSidebar);
  };

  return (
    <div className="min-h-screen bg-[#FCFCFD] text-sm">
      {/* Sidebar único - sempre renderizado, mas com posicionamento condicional */}
      <div 
        className={cn(
          isMobile 
            ? cn(
                'fixed inset-y-0 left-0 z-30 transition-transform duration-300 ease-in-out transform',
                showMobileSidebar ? 'translate-x-0' : '-translate-x-full'
              )
            : 'fixed inset-y-0 left-0 z-50'
        )}
      >
        <Sidebar />
      </div>

      {/* Mobile sidebar overlay */}
      {isMobile && showMobileSidebar && (
        <div 
          className="fixed inset-0 bg-black/40 z-20 transition-opacity"
          onClick={() => setShowMobileSidebar(false)}
        />
      )}

      {/* Main content */}
              <div 
          className={cn(
            'min-h-screen flex flex-col transition-all duration-300 ease-in-out',
            isMobile 
              ? 'ml-0' 
              : (collapsed ? 'ml-16' : 'ml-64')
          )}
        >
        {/* Main content container without excessive padding */}
        <main className="flex-1 w-full">
          {children}
        </main>
      </div>
    </div>
  );
}
